import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import { useTranslation } from "react-i18next";

import AuthUser from "../../../../components/AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../../../components/Spinner";

const CrewChangeFilter = ({ onFilterSubmit, projetos }) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao } = AuthUser();

  const [nomeFilter, setNomeFilter] = useState("");
  const [siglaFilter, setSiglaFilter] = useState("");
  const [projetoFilter, setProjetoID] = useState("-1");
  const [estadoFilter, setEstadoFilter] = useState("-1");

  const [data1, setData1] = useState("1900-12-31");
  const [data2, setData2] = useState("2099-12-31");

  const [itemFocus, setItemFocus] = useState(false);

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const [crew_changes, setcrew_changes] = useState([]);

  const inputFocus = () => {
    setItemFocus(true);
  };

  const inputBlur = () => {
    setItemFocus(false);
  };

  const handleSubmitFiltercrew_changes = async () => {
    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("colaborador_id", "-1");
      formData.append("data1", data1);
      formData.append("data2", data2);
      formData.append("estado", estadoFilter);
      formData.append("posto_id", projetoFilter);

      const res = await http.post("/filtrar-crew-change", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const crew_changes = res?.data?.crew_changes || [];
      setcrew_changes(crew_changes);

      onFilterSubmit(crew_changes);
    } catch (error) {
      console.error(error);
      //notifyError("Error searching certificates.");
    } finally {
      setLoading(false);
    }
  };

  const renderOptionPostos = (postos) => {
    return postos?.map((posto) => (
      <React.Fragment key={posto.id}>
        <option value={posto.id}>
          {posto.codigo + " - " + posto?.cliente?.nome}
        </option>
      </React.Fragment>
    ));
  };

  return (
    <div className="row filter-row space">
      <div className="col-sm-10 col-md-2">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <input
            type="text"
            name="nameFilter"
            className="form-control floating"
            onFocus={inputFocus}
            onBlur={inputBlur}
            value={nomeFilter}
            onChange={(e) => setNomeFilter(e.target.value)}
          />
          <label className="focus-label">{t("Name")}</label>
        </div>
      </div>

      <div className="col-sm-12 col-md-2">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <input
            type="date"
            name="nameFilter"
            className="form-control floating"
            value={data1}
            onChange={(e) => setData1(e.target.value)}
          />
          <label className="focus-label">{t("Data1")}</label>
        </div>
      </div>
      <div className="col-sm-12 col-md-2">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <input
            type="date"
            name="nameFilter"
            className="form-control floating"
            value={data2}
            onChange={(e) => setData2(e.target.value)}
          />
          <label className="focus-label">{t("Data2")}</label>
        </div>
      </div>

      <div className="col-sm-12 col-md-2">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <select
            className="form-control select"
            onChange={(e) => setProjetoID(e.target.value)}
          >
            <option value={-1}>Escolha o projeto</option>
            {renderOptionPostos(projetos)}
          </select>
          <label className="focus-label">{t("Projeto")}</label>
        </div>
      </div>

      <div className="col-sm-12 col-md-2">
        <div
          className={`input-block mb-3 form-focus  ${
            itemFocus ? "focused" : ""
          } `}
        >
          <select
            className="form-control select"
            onChange={(e) => setEstadoFilter(e.target.value)}
          >
            <option value={-1}>Defina o estado</option>
            <option value={1}>Entrou</option>
            <option value={2}>Saiu</option>
          </select>
          <label className="focus-label">{t("Estado")}</label>
        </div>
      </div>

      <div className="col-sm-6 col-md-2">
        <span
          className="btn btn-success btn-block w-100"
          onClick={() => handleSubmitFiltercrew_changes()}
        >
          {loading ? (
            <i className="fa fa-spinner fa-spin me-2"></i>
          ) : (
            t("Search")
          )}
        </span>
      </div>

      <ToastContainer />
    </div>
  );
};

export default CrewChangeFilter;
